import React, { useState, useEffect, useMemo } from 'react';
import {Container ,Breadcrumb, Row, Col} from "react-bootstrap";
import MainNav from "../../blocks/MainNav";
import {NavLink} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft, faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
const styles = {
    wrapper: {
        fontFamily:
            'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
        fontSize: '16px',              // крупнее базового 13px — под тач-терминал
        lineHeight: 1.5,
        color: '#333',
        padding: '24px',
        maxWidth: '1100px',
        margin: '0 auto',
       
    },
    card: {
        background: '#fff',
        border: '1px solid rgba(0,0,0,.125)',        
        boxShadow: '0 1px 2px rgba(0,0,0,.05)',
        overflow: 'hidden',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '16px',
    },
    th: {
        background: '#f5f5f5',
        color: '#333',
        padding: '16px 20px',
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '15px',
        borderBottom: '1px solid #ddd',
        whiteSpace: 'nowrap',
    },
    td: {
        padding: '16px 20px',
        borderBottom: '1px solid #ddd',
        fontSize: '16px',
        color: '#333',
        verticalAlign: 'middle',
    },
    row: (isSelected) => ({
        cursor: 'pointer',
        background: isSelected ? 'rgba(30, 135, 74, 0.08)' : '#fff',
        transition: 'background .15s ease-in-out',
    }),
    footer: {
        display: 'flex',
        gap: '24px',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '20px',
        background: '#fafafa',
        borderTop: '1px solid #ddd',
        fontSize: '16px',
        color: '#333',
    },
    counter: {
        color: '#777',
        fontSize: '16px',
    },
    counterValue: {
        color: '#333',
        fontWeight: 600,
        fontSize: '18px',
    },
    button: (disabled) => ({
        marginLeft: 'auto',
        minHeight: '48px',
        padding: '12px 28px',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.4,
        color: '#fff',
        background: '#1E874A',
        border: '1px solid #1E874A',        
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.65 : 1,
        transition: 'background .15s ease-in-out, border-color .15s ease-in-out',
        touchAction: 'manipulation',
    }),
    empty: {
        padding: '32px',
        textAlign: 'center',
        color: '#999',
        fontSize: '16px',
        background: '#fff',
        border: '1px solid rgba(0,0,0,.125)',        
        boxShadow: '0 1px 2px rgba(0,0,0,.05)',
    },
    checkbox: {
        width: '24px',
        height: '24px',
        cursor: 'pointer',
        margin: 0,
        accentColor: '#455A64',        // slate-700 — отметка по дизайн-системе
        verticalAlign: 'middle',
    },
    thCheckbox: {
        background: '#f5f5f5',
        padding: '16px 20px',
        width: '24px',
        borderBottom: '1px solid #ddd',
    },

    // ----- Модальное окно -----
    modalBackdrop: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1050,
        padding: '24px',
    },
    modalContent: {
        background: '#fff',        
        boxShadow: '0 4px 8px rgba(0,0,0,.1)',
        border: '1px solid rgba(0,0,0,.2)',
        width: '100%',
        maxWidth: '820px',
        maxHeight: 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
    },
    modalHeader: {
        padding: '24px 24px 16px',
        borderBottom: '1px solid rgba(0,0,0,.125)',
        fontSize: '22px',
        fontWeight: 500,
        color: '#333',
    },
    modalBody: {
        padding: '24px',
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        overflowY: 'auto',
        justifyContent:'center'
    },
    modalFooter: {
        padding: '16px 24px 24px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
    },
    modeButton: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '20px 24px',
        minHeight: '120px',
        background: '#fff',
        border: '2px solid #ddd',        
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'border-color .15s ease-in-out, background .15s ease-in-out',
        touchAction: 'manipulation',
        fontFamily: 'inherit',
        alignItems:'center'
    },
    modeButtonTitle: {
        fontSize: '20px',
        fontWeight: 600,
        color: '#1E874A',
        lineHeight: 1.3,
        textAlign:'center'
    },
    modeButtonDesc: {
        fontSize: '14px',
        color: '#555',
        lineHeight: 1.5,
        whiteSpace: 'pre-line',
    },
    cancelButton: {
        minHeight: '48px',
        padding: '12px 28px',
        fontSize: '16px',
        fontWeight: 500,
        color: '#333',
        background: '#fafafa',
        border: '1px solid #ddd',        
        cursor: 'pointer',
        transition: 'background .15s ease-in-out',
        touchAction: 'manipulation',
    },
};

const MODES = {
    SPRINT: 'sprint',
    MARATHON: 'marathon',
};

export default function TestTrainingTable(props) {
    const [selectedTests, setSelectedTests] = useState([]);
    const [loadedTests, setLoadedTests] = useState(props.loadedTests);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        setLoadedTests(props.loadedTests);
        setSelectedTests([]);
    }, [props.loadedTests]);

    const testsEntries = useMemo(() => {
        if (
            loadedTests &&
            typeof loadedTests === 'object' &&
            !Array.isArray(loadedTests)
        ) {
            return Object.entries(loadedTests);
        }
        return [];
    }, [loadedTests]);

    const toggleTest = (key) => {
        setSelectedTests((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        );
    };

    const toggleAll = () => {
        if (selectedTests.length === testsEntries.length) {
            setSelectedTests([]);
        } else {
            setSelectedTests(testsEntries.map(([key]) => key));
        }
    };

    // Открыть модалку вместо прямого вызова handleSelectTests
    const handleConfirm = () => {
        if (selectedTests.length === 0) return;
        setIsModalOpen(true);
    };

    // Выбор режима → отправка в родителя
    const handleModeSelect = (mode) => {
        const selectedData = testsEntries
            .filter(([key]) => selectedTests.includes(key))
            .map(([key, item]) => ({ key, ...item }));

        props.handleSelectTests?.(selectedData, mode);
        setIsModalOpen(false);
    };

    const selectedCount = selectedTests.length;
    const totalTasks = testsEntries
        .filter(([key]) => selectedTests.includes(key))
        .reduce((sum, [, item]) => sum + (item?.questions?.length ?? 0), 0);

    if (testsEntries.length === 0) {
        return (
            <>
            <div className="Screen container mx-auto">
                <div style={styles.wrapper}>
                    <div style={styles.empty}>Нет доступных тестов</div>
                </div>
            </div>
             <MainNav>
                    <Container className={`d-flex justify-content-between`}>
                                <NavLink to={"/cabinet"} className={`Btn Btn_success MuiButton`}>
                                    <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                                    <span>{props.t('Personal Area')}</span>
                                </NavLink>
                                <NavLink to={"/"} className={`Btn Btn_danger MuiButton`}>
                                    <FontAwesomeIcon className="mr-4" icon={faSignOutAlt}/>
                                    <span>{props.t('Exit')}</span>
                                </NavLink>
                            </Container>
                        </MainNav>

            </>
            
        );
    }

    const allSelected = selectedTests.length === testsEntries.length;
    const isConfirmDisabled = selectedCount === 0;

    return (
        <>
        <div className="Screen container mx-auto">
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.thCheckbox}>
                                <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={toggleAll}
                                    aria-label="Выбрать все"
                                    style={styles.checkbox}
                                />
                            </th>
                            <th style={styles.th}>Номер теста</th>
                            <th style={styles.th}>Название теста</th>
                            <th style={styles.th}>Количество задач</th>
                        </tr>
                    </thead>
                    <tbody>
                        {testsEntries.map(([key, item]) => {
                            const isSelected = selectedTests.includes(key);
                            return (
                                <tr
                                    key={key}
                                    onClick={() => toggleTest(key)}
                                    style={styles.row(isSelected)}
                                    onMouseEnter={(e) => {
                                        if (!isSelected)
                                            e.currentTarget.style.background =
                                                'rgba(0,0,0,.03)';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isSelected)
                                            e.currentTarget.style.background = '#fff';
                                    }}
                                >
                                    <td style={styles.td}>
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => toggleTest(key)}
                                            onClick={(e) => e.stopPropagation()}
                                            style={styles.checkbox}
                                        />
                                    </td>
                                    <td style={styles.td}>{key}</td>
                                    <td style={styles.td}>
                                        {item?.title ?? '—'}
                                    </td>
                                    <td style={styles.td}>
                                        {item?.questions?.length ?? 0}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <div style={styles.footer}>
                    <span style={styles.counter}>
                        Выбрано тестов:{' '}
                        <span style={styles.counterValue}>{selectedCount}</span>
                    </span>
                    <span style={styles.counter}>
                        Суммарно задач:{' '}
                        <span style={styles.counterValue}>{totalTasks}</span>
                    </span>
                    <button
                        onClick={handleConfirm}
                        disabled={isConfirmDisabled}
                        style={styles.button(isConfirmDisabled)}
                        onMouseEnter={(e) => {
                            if (!isConfirmDisabled)
                                e.currentTarget.style.background = '#186b3a';
                        }}
                        onMouseLeave={(e) => {
                            if (!isConfirmDisabled)
                                e.currentTarget.style.background = '#1E874A';
                        }}
                    >
                        Подтвердить выбор
                    </button>
                </div>
            </div>
           
            {isModalOpen && (
                <div
                    style={styles.modalBackdrop}
                    onClick={() => setIsModalOpen(false)}
                >
                    <div
                        style={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={styles.modalHeader}>
                            Выберите режим тренировок
                        </div>

                        <div style={styles.modalBody}>
                            <button
                                type="button"
                                style={styles.modeButton}
                                onClick={() => handleModeSelect(MODES.SPRINT)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#1E874A';
                                    e.currentTarget.style.background =
                                        'rgba(30,135,74,.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#ddd';
                                    e.currentTarget.style.background = '#fff';
                                }}
                            >
                                <span style={styles.modeButtonTitle}>
                                    Спринт на время
                                </span>
                                <span style={styles.modeButtonDesc}>
                                    {`Проверьте скорость и внимательность:\n* 10 минут, задачи в случайном порядке,\n* максимальный комплекс 20 задач,\n* при завершении комплекта — конец спринта.`}
                                </span>
                            </button>

                            <button
                                type="button"
                                style={styles.modeButton}
                                onClick={() => handleModeSelect(MODES.MARATHON)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#1E874A';
                                    e.currentTarget.style.background =
                                        'rgba(30,135,74,.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#ddd';
                                    e.currentTarget.style.background = '#fff';
                                }}
                            >
                                <span style={styles.modeButtonTitle}>
                                    Марафон по всем задачам
                                </span>
                                <span style={styles.modeButtonDesc}>
                                    {`Дойдите до финиша: решайте задачи одну за другой,\nпока не закроете весь набор.\nНикаких повторов и ограничений по времени —\nтолько упорство и результат.`}
                                </span>
                            </button>
                        </div>

                        <div style={styles.modalFooter}>
                            <button
                                type="button"
                                style={styles.cancelButton}
                                onClick={() => setIsModalOpen(false)}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.background = '#f5f5f5')
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = '#fafafa')
                                }
                            >
                                Отмена
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
         <MainNav>
                            <Container className={`d-flex justify-content-between`}>
                                <NavLink to={"/cabinet"} className={`Btn Btn_success MuiButton`}>
                                    <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                                    <span>{props.t('Personal Area')}</span>
                                </NavLink>
                                <NavLink to={"/"} className={`Btn Btn_danger MuiButton`}>
                                    <FontAwesomeIcon className="mr-4" icon={faSignOutAlt}/>
                                    <span>{props.t('Exit')}</span>
                                </NavLink>
                            </Container>
                        </MainNav>
</>
    );
}